<template>
    <PopoverPortal :disabled="!teleport">
        <PopoverContent
            v-bind="{ ...forwarded, ...$attrs }"
            :class="
                cn(
                    'ds-popover-content',
                    // shadcn state control classes
                    'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
                    props.class,
                )
            "
        >
            <slot />
        </PopoverContent>
    </PopoverPortal>
</template>

<script setup lang="ts">
import type { DsPopoverContentEmits, DsPopoverContentProps } from '@/components/design-system/popover/ds-popover.types';
import { cn } from '@/lib/utils';
import { reactiveOmit } from '@vueuse/core';
import { PopoverContent, PopoverPortal, useForwardPropsEmits } from 'reka-ui';

defineOptions({
    inheritAttrs: false,
});

const props = withDefaults(defineProps<DsPopoverContentProps>(), {
    align: 'center',
    alignOffset: 0,
    sideOffset: 4,
    sideFlip: true,
    alignFlip: true,
    avoidCollisions: true,
});
const emits = defineEmits<DsPopoverContentEmits>();

const delegatedProps = reactiveOmit(props, 'class', 'teleport');

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<style lang="scss">
.ds-popover-content {
    @apply z-50 min-w-3 rounded-lg border border-ds-primary-200 bg-white shadow-popover outline-none;
    contain: layout;
}
</style>
